import React from "react"
import { Switch, Route, Router, Redirect } from "react-router-dom"

import history from "./history"
import { isAuthenticated, path as pathHome } from "../core/utils"

import Header from "../components/Header"
import Contratos from "../pages/Contratos"
import ContratoDetail from "../pages/ContratoDetail"
import Extratos from "../pages/Extratos"
import Boletos from "../pages/Boletos"
import Imoveis from "../pages/Imoveis"

import Login from "../pages/Login"
import RecuperarSenha from "../pages/RecuperarSenha"

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: pathHome + "/login", state: { from: props.location } }} />
            )
        }
    />
)

const App = props => {
    return (
        <section>
            <Header />
            <Switch>
                <PrivateRoute exact path={pathHome + "/"} component={Imoveis} />
                <PrivateRoute path={pathHome + "/imoveis"} component={Imoveis} />
                <PrivateRoute path={pathHome + "/contratos/:id"} component={ContratoDetail} />
                <PrivateRoute path={pathHome + "/contratos"} component={Contratos} />
                <PrivateRoute path={pathHome + "/extratos"} component={Extratos} />
                <PrivateRoute path={pathHome + "/boletos"} component={Boletos} />
            </Switch>
        </section>
    )
}

const Routes = () => (
    <Router history={history}>
        <Switch>
            <Route exact path={pathHome + "/login"} component={Login} />
            <Route exact path={pathHome + "/recuperar-senha"} component={RecuperarSenha} />
            <Route path={pathHome + "/"} component={App} />
        </Switch>
    </Router>
)

export default Routes
